import { Rule, RuleObject, RuleRender } from 'rc-field-form/lib/interface';
import InternalForm, { useForm, FormInstance, FormProps } from './utils/Form';
import Item, { FormItemProps } from './utils/FormItem';
import ErrorList, { ErrorListProps } from './utils/ErrorList';
import List, { FormListProps } from './utils/FormList';
import { FormProvider } from './utils/context';
import devWarning from './utils/devWarning';
import "@whalecloud/fdx-theme-fdx/simple-form/index";

type InternalFormType = typeof InternalForm;

interface FormInterface extends InternalFormType {
  useForm: typeof useForm;
  Item: typeof Item;
  List: typeof List;
  ErrorList: typeof ErrorList;
  Provider: typeof FormProvider;

  /** @deprecated Only for warning usage. Do not use. */
  create: () => void;
}

const Form = InternalForm as FormInterface;

Form.Item = Item;
Form.List = List;
Form.ErrorList = ErrorList;
Form.useForm = useForm;
Form.Provider = FormProvider;
Form.create = () => {
  devWarning(
    false,
    'Form',
    'antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.',
  );
};

export {
  FormInstance,
  FormProps,
  FormItemProps,
  ErrorListProps,
  Rule,
  RuleObject,
  RuleRender,
  FormListProps,
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/simple-form/index.tsx